export const SHORTCUTS_KEY = "fp_shortcuts";

export function loadShortcuts() {
  try { return JSON.parse(localStorage.getItem(SHORTCUTS_KEY)) || []; } catch { return []; }
}

export function saveShortcuts(list) {
  try { localStorage.setItem(SHORTCUTS_KEY, JSON.stringify(list)); } catch { /* ignore */ }
  window.dispatchEvent(new Event("fp-shortcuts-changed"));
}

// Build a normalized combo string from a keyboard event, e.g. "ctrl+shift+k"
export function normalizeCombo(e) {
  const parts = [];
  if (e.ctrlKey) parts.push("ctrl");
  if (e.altKey) parts.push("alt");
  if (e.shiftKey) parts.push("shift");
  if (e.metaKey) parts.push("meta");
  let k = (e.key || "").toLowerCase();
  if (k === " ") k = "space";
  if (!["control", "alt", "shift", "meta"].includes(k)) parts.push(k);
  return parts.join("+");
}

const LBL = { ctrl: "Ctrl", alt: "Alt", shift: "Shift", meta: "Cmd", space: "Spacja", escape: "Esc",
  arrowup: "↑", arrowdown: "↓", arrowleft: "←", arrowright: "→", enter: "Enter", tab: "Tab", backspace: "Backspace" };

export function comboToLabel(c) {
  if (!c) return "";
  return c.split("+").map((p) => LBL[p] || (p.length === 1 ? p.toUpperCase() : p.charAt(0).toUpperCase() + p.slice(1))).join(" + ");
}

export const OTHER_ACTIONS = [
  ["global:close", "Zamknij otwarty panel"],
  ["global:fullscreen", "Pełny ekran panelu"],
  ["action:import", "Import danych"],
  ["action:export", "Eksport danych"],
];

export const PANEL_ACTIONS = [
  ["panel:settings", "Otwórz: Ustawienia"],
  ["panel:invoices", "Otwórz: Faktury"],
  ["panel:warehouse", "Otwórz: Magazyn"],
  ["panel:stats", "Otwórz: Statystyki"],
  ["panel:faults", "Otwórz: Awarie"],
  ["panel:snmp", "Otwórz: SNMP / Monitoring"],
  ["panel:ping", "Otwórz: Ping"],
  ["panel:reports", "Otwórz: Raporty"],
  ["panel:help", "Otwórz: Pomoc"],
  ["panel:ai", "Otwórz: Asystent AI"],
  ["panel:connections", "Otwórz: Połączenia"],
  ["panel:reservations", "Otwórz: Rezerwacje"],
  ["panel:schedule", "Otwórz: Terminarz"],
  ["panel:qrlabels", "Otwórz: Etykiety QR"],
  ["panel:users", "Otwórz: Pracownicy"],
  ["panel:requests", "Otwórz: Wnioski / Aneksy"],
  ["panel:pituke", "Otwórz: PIT / UKE"],
];

export function buildActionList(MODULES) {
  const mods = Object.keys(MODULES || {}).map((k) => [`module:${k}`, `Moduł: ${MODULES[k]?.label || k}`]);
  return [...OTHER_ACTIONS, ...PANEL_ACTIONS, ...mods];
}
